import { render } from "./PastEvents.vue?vue&type=template&id=394be3af"
import script from "./PastEvents.vue?vue&type=script&lang=js"
export * from "./PastEvents.vue?vue&type=script&lang=js"

import "./PastEvents.vue?vue&type=style&index=0&id=394be3af&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__